import LoadingSpinner from 'components/progress/LoadingSpinner';
import Wopi from 'components/surfaces/Wopi';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import fetchRequest from 'services/api';
import { checkScreenWidth } from 'utils/helpers';
import { MessageBar, MessageBarType } from '@fluentui/react';

function DownLoadDocumentContainer() {
  const { t } = useTranslation();

  const [initialized, setInitialized] = useState(null);

  const [wopiUrl, setWopiUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const { fileId, tenantId } = useParams();

  function getFile(file) {
    fetchRequest({ url: `File/${file.id}` })
      .then((response) => {
        setWopiUrl(response.wopiUrl);
        setLoading(false);
      })
      .catch(() => {
        setError(true);
      });
  }

  useEffect(() => {
    if (!initialized && tenantId) {
      window.localStorage.setItem('tenantId', tenantId);
      setInitialized(true);
    }
  }, [tenantId, initialized]);

  useEffect(() => {
    if (initialized) {
      getFile({ id: fileId });
    }
  }, [initialized, fileId]);

  if (error) {
    return <div>Something went wrong</div>;
  }

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!wopiUrl) return null;

  if (checkScreenWidth(['extraSmall', 'small'])) {
    return (
      <>
        <MessageBar messageBarType={MessageBarType.warning} isMultiline>
          {t('wopi.mobileWarning')}
        </MessageBar>
        <Wopi styles={{ iframe: { top: 45 } }} url={wopiUrl} />
      </>
    );
  }

  return <Wopi url={wopiUrl} />;
}

export default DownLoadDocumentContainer;
